module.exports = __webpack_public_path__ + "img/universe.d973ae84.jpg";